import app from './app/reducers'
import me from './me/reducers'


export default {
  app,
  me,
}
